module.exports = __webpack_public_path__ + "assets/9c89cac3a2506cf972c7ce16ab18b870.png";